import React from 'react';
// import imgLogo from '@/images/WorkPoint.png';
// import imgLogo from '@/images/WorkPoint.svg';
// import imgLogo from '@/images/logo_wp_blanc.svg';
import imgLogo from '@/images/wpBrand.svg';
import { Heading, Stack } from 'rsuite';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function Logo({ width, height, style, className = '' }: LogoProps) {
  const styles = { width, height, display: 'inline-block', ...style };
  return (
    // <div
    //   style={styles}
    //   className={`rsuite-logo logo-animated logo-animated-delay-half-seconds bounce-in ${className} `}
    // >
    <Stack
      // style={styles}
      // direction="row"
      justifyContent="center"
      alignItems="center"
      className={`rsuite-logo logo-animated logo-animated-delay-half-seconds bounce-in ${className} `}
      direction="column"
      spacing={5}
      style={{ marginTop: 5 }}
    >
      <img width={30} src={imgLogo} />
      <Heading level={4} style={{ color: '#145199', fontFamily: 'nunito ' }}>
        WorkPoint
      </Heading>
    </Stack>
    // </div>
  );
}
